(function () {
  const root = document.querySelector(".nlp-steps");
  if (!root || root.dataset.init === "1") return;
  root.dataset.init = "1";

  const gsap = window.gsap;
  if (!gsap) return;

  const prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const hasST = !!window.ScrollTrigger;
  if (hasST) gsap.registerPlugin(window.ScrollTrigger);

  const title = root.querySelector(".nlp-steps__title");
  const cards = Array.from(root.querySelectorAll(".nlp-steps__card"));
  const nums = Array.from(root.querySelectorAll(".nlp-steps__num"));

  // Optional: if you have a divider element you can target
  // (If not present, this safely does nothing.)
  const topLines = Array.from(root.querySelectorAll(".nlp-steps__line"));

  const triggerConfig = hasST
    ? { trigger: root, start: "top 80%", once: true }
    : null;

  if (prefersReduced) {
    // Make sure everything is visible if reduced motion
    if (title) title.style.opacity = "1";
    cards.forEach((c) => (c.style.opacity = "1"));
    return;
  }

  const tl = gsap.timeline({
    defaults: { ease: "power2.out" },
    scrollTrigger: triggerConfig || undefined,
  });

  // Title
  if (title) {
    tl.fromTo(
      title,
      { opacity: 0, y: 18 },
      { opacity: 1, y: 0, duration: 0.9 },
      0,
    );
  }

  // Optional divider line (only if you add an element .nlp-steps__line)
  if (topLines.length) {
    topLines.forEach((line) => {
      tl.fromTo(
        line,
        { scaleX: 0, transformOrigin: "0% 50%" },
        { scaleX: 1, duration: 0.7 },
        0.1,
      );
    });
  }

  // Cards
  if (cards.length) {
    tl.fromTo(
      cards,
      { opacity: 0, y: 26 },
      { opacity: 1, y: 0, duration: 0.85, stagger: 0.12 },
      title ? 0.15 : 0,
    );
  }

  // Numbers (subtle pop/blur) – runs after cards start
  if (nums.length) {
    tl.fromTo(
      nums,
      { opacity: 0, y: 8, filter: "blur(6px)" },
      {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 0.6,
        stagger: 0.12,
      },
      0.25,
    );
  }
})();
